import { Stack } from '@tempots/beatui'
import { attr, html, TNode } from '@tempots/dom'

export function OnboardingLayout(_options: object, ...content: TNode[]) {
  return html.div(
    attr.class('flex justify-center md:grid md:grid-cols-5 h-full'),
    Stack(
      attr.class(
        'gap-4 flex flex-col justify-center items-center col-span-3 w-full px-4 py-8 md:px-8 md:py-0 overflow-y-auto'
      ),
      ...content
    ),
    Stack(
      attr.class(
        'gap-4 bg-[#FFFAF8] hidden md:flex flex-col justify-center items-center col-span-2'
      ),
      html.img(
        attr.class('w-full h-auto max-w-md'),
        attr.src('/onboarding-splash-page.svg')
      )
    )
  )
}
